import React, { useState, useEffect } from 'react'
import { Message } from 'rsuite'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import '../styles.less'
import CloseProjectWidget from '../../../widgets/closeProject/CloseProjectWidget'
import ProgressAssetWiget from '../../../widgets/progressReportWidget/ProgressAssetWidget'

import { startLoading, doneLoading } from '../../../utils/loading'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import PdfRenderWidgets from '../../../widgets/pdfWidgets/PdfRenderWidgets'
import { contractCenterApproveCloseOfProjectForm } from '../../../redux/actions/closeOfProject'
import AgreementAdditionalWidgets from '../../../widgets/agreementAdditional/AgreementAdditionalWidgets'
import CloseProjectStaffWidget from '../../../widgets/closeProject/CloseProjectStaffWidget'
import CloseProjectApproveWidget from '../../../widgets/closeProject/CloseProjectApproveWidget'
import CloseProjectContractCenterWidget from '../../../widgets/closeProject/CloseProjectContractCenterWidget'
import { downloadProgressFile } from '../../../redux/actions/projectProgress'
import CoworkerEvaluateYourselfWidget from '../../../widgets/evaluatesWidgets/coworkerEvaluateYourselfWidgets/CoworkerEvaluateYourselfWidget'
import DirectorEvaluateCloseProjectWidgets from '../../../widgets/evaluatesWidgets/directorEvaluateCloseProjectWidgets/DirectorEvaluateCloseProjectWidgets'
import CloseProjectReviewerWidget from '../../../widgets/closeProject/CloseProjectReviewerWidget'
import { getAssessmentClosureApprove, getAssessmentForm } from '../../../redux/actions/assessment'
import EvaluationViewClosureWidget from '../../../widgets/evaluationForm/EvaluationViewClosureWidget'
import { DEFAULT_ERR_MSG } from '../../../constants/msgText'

export default function CloseOfProjectApprove(props) {
  //ปิดโครงการ (จนท.ศูนย์สัญญา)
  const [isLoading, setIsLoading] = useState(false)
  const [schemas, setSchemas] = useState()
  const [error, setError] = useState()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  const [isPdfError, setIsPdfError] = useState(false)
  const [previewPdf, setPreviewPdf] = useState()
  const [isLoadingPDF, setIsLoadingPDF] = useState(false)

  const [assessmentSchema, setAssessmentSchema] = useState()
  const [assessmentError, setAssessmentError] = useState()

  useEffect(() => {
    console.log('CloseOfProject', projectId)
    projectId && handleGetSchema(projectId)
    projectId && handleGetAssessmentSchema(projectId)
    // projectId && handleGetDownloadProgressFile(projectId)
  }, [projectId])

  const handleGetSchema = async (proposalId) => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await contractCenterApproveCloseOfProjectForm(proposalId)
      // console.log('_schema_schema_schema ', _schema)
      if (_schema.success) {
        setSchemas(_schema.model)
        setProjectProgressId(_schema.model.forms.projectProgressId)
      }
    } catch (e) {}
    doneLoading()
    setIsLoading(false)
  }

  const handleGetDownloadProgressFile = async (projectId) => {
    startLoading()
    //setIsLoading(true)
    setIsPdfError(false)
    setIsLoadingPDF(true)
    try {
      const progressId = schemas.forms.projectProgressId || ''
      const response = await downloadProgressFile(projectId, progressId)
      console.log('response preview pdf', response)
      if (response) {
        setPreviewPdf(response)
        setIsPdfError(false)
      } else {
        setIsPdfError(true)
      }
    } catch (e) {
      console.log('error ', e)
      setIsPdfError(true)
    }
    //setIsLoading(false)
    setIsLoadingPDF(false)
    doneLoading()
  }

  const handleGetAssessmentSchema = async (projectId) => {
    setIsLoading(true)
    startLoading()

    try {
      const response = await getAssessmentClosureApprove(null, projectId)
      if (response) {
        setAssessmentSchema(response.forms)
      }
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setAssessmentError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message || DEFAULT_ERR_MSG,
        })
      } else {
        setAssessmentError({})
      }
    }

    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schemas || isLoading) {
    return (
      <SidebarProposal>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <>
      <SidebarProposal>
        <ContentHeader header={schemas.header} subHeader={schemas.subHeader} />

        {schemas?.forms?.agreementDetails && (
          <AgreementAdditionalWidgets formSchema={schemas.forms.agreementDetails} />
        )}

        {/* {schemas?.forms?.lessonSummary && (
          <>
            <LessonSummaryWidget
              showCommandButton={!schemas.forms.lessonSummary.disabled}
              schema={schemas.forms.lessonSummary}
            />
            <br />
          </>
        )} */}

        {/* ผลการประเมิน */}
        <>
          {assessmentError ? (
            <Panel shaded collapsible defaultExpanded header={'แบบประเมิน'} bordered>
              <Message
                showIcon
                type="error"
                description={`${assessmentError.statusCode} ${assessmentError.errorMessage}`}
              />
            </Panel>
          ) : (
            assessmentSchema && (
              <>
                <EvaluationViewClosureWidget
                  schema={assessmentSchema}
                />
              </>
            )
          )}
          <br/>
          {/* <DirectorEvaluateCloseProjectWidgets projectId={projectId} projectProgressId={99} /> */}
        </>

        {schemas?.forms?.projectEquipment && (
          <>
            <ProgressAssetWiget schema={schemas.forms.projectEquipment} />
            <br />
          </>
        )}

        {/* {schemas?.forms?.financialReport && (
          <>
            <FinancialReportWidget
              showCommandButton={!schemas.forms.financialReport.disabled}
              schema={schemas.forms.financialReport}
            />
            <br />
          </>
        )} */}

        {/*นักวิชาการ*/}
        {schemas?.forms?.requestNoteStaff && schemas?.forms?.projectEvaluation && (
          <>
            <CloseProjectStaffWidget
              showCommandButton={!schemas?.forms?.requestNoteStaff?.disabled}
              schema={schemas?.forms?.requestNoteStaff}
              schemaEvaluate={schemas?.forms?.projectEvaluation}
              evaluateDisabled={schemas?.forms?.projectEvaluation.disabled || true}
            />
            <br />
          </>
        )}

        {/*ภาคี*/}
        {schemas?.forms?.requestNote && (
          <>
            <CloseProjectWidget
              showCommandButton={!schemas.forms.requestNote.disabled}
              schema={schemas.forms.requestNote}
              // isApprove={true}
            />
            <br />
          </>
        )}

        {/*ผอ.*/}
        {schemas?.forms?.requestNoteApprove && (
          <>
            <CloseProjectApproveWidget
              showCommandButton={!schemas.forms.requestNoteApprove.disabled}
              schema={schemas.forms.requestNoteApprove}
            />
            <br />
          </>
        )}

        {/*เจ้าหน้าที่พัสดุ กับ เจ้าหน้าที่การเงิน*/}
        {schemas?.forms?.reviewStep && (
          <>
            <CloseProjectReviewerWidget
              // showCommandButton={!schemas.forms.reviewStep.disabled}
              schema={schemas.forms.reviewStep}
            />
            <br />
          </>
        )}

        {/*ศูนย์สัญญา*/}
        {schemas?.forms?.contractCenterNote && (
          <>
            <CloseProjectContractCenterWidget
              showCommandButton={!schemas.forms.contractCenterNote.disabled}
              schema={schemas.forms.contractCenterNote}
            />
            <br />
          </>
        )}

        {/* {schemas?.forms?.sendContractCloseOfProject && (
          <>
            <SendContractCloseProjectWidget
              showCommandButton={!schemas.forms.sendContractCloseOfProject.disabled}
              schema={schemas.forms.sendContractCloseOfProject}
            />
            <br />
          </>
        )} */}

        {isPdfError ? (
          <>
            <Message showIcon type="error" description={'ไม่พบไฟล์ PDF'} />
            <br />
          </>
        ) : (
          <>
            <PdfRenderWidgets
              file={previewPdf}
              isLoading={isLoadingPDF}
              header={'เอกสารที่เกี่ยวข้องกับการปิดโครงการ'}
              fileName={'เอกสารที่เกี่ยวข้องกับการปิดโครงการ'}
              onReload={() => handleGetDownloadProgressFile(projectId)}
              loadingMessage={'เอกสารที่เกี่ยวข้องกับการปิดโครงการ'}
              firstExpandToReload={true}
            />
            <br />
          </>
        )}
      </SidebarProposal>
    </>
  )
}
